import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Founder } from '../../api/founders';
import { useFoundersContext } from '../../contexts/founders-context';
import { UserContext } from '../../contexts/user-context';
import { getRoutePath, Pages } from '../../router/constants';
import TableActions from '../common/table-actions';

function FoundersRowActions({
  founder,
  variant,
}: {
  founder: Founder;
  variant?: 'table' | 'list';
}) {
  const history = useHistory();
  const location = useLocation();
  const { hasAccessToAction } = useContext(UserContext);
  const {
    setProfileUpdateTargetFounderId,
    setAssignTargetFounder,
    setInviteTargetFounderId,
    setArchiveTargetFounders,
  } = useFoundersContext();

  const prevPath = `${location.pathname}${location.search}`;

  return (
    <TableActions
      variant={variant}
      actions={[
        {
          key: 'row-action-note',
          onClick: () =>
            history.push({
              pathname: getRoutePath(Pages.FOUNDER_NOTES, {
                founderId: founder.id,
              }),
              state: { prevPath },
            }),
          icon: <AddIcon fontSize='small' color='inherit' />,
          label: 'Note',
          hidden: !hasAccessToAction('founder.notes.view'),
        },
        {
          key: 'row-action-enrich',
          onClick: () =>
            history.push({
              pathname: getRoutePath(Pages.FOUNDER_DETAILS, {
                founderId: founder.id,
              }),
              state: { prevPath, openEnrichModal: true },
            }),
          label: 'Enrich Profile',
          hidden: !hasAccessToAction('founder.updateProfile'),
        },
        {
          key: 'row-action-request-profile-update',
          onClick: () => setProfileUpdateTargetFounderId(founder.id),
          label: 'Request Profile Update',
          hidden: !hasAccessToAction('founder.details.update'),
        },
        {
          key: 'row-action-assign-founder',
          onClick: () => setAssignTargetFounder(founder),
          label: 'Assign',
          hidden: !hasAccessToAction('founder.details.update'),
        },
        {
          key: 'row-action-invite-founder',
          onClick: () => setInviteTargetFounderId(founder.id),
          label: 'Send Invite',
          hidden: !hasAccessToAction('userManagement.founder'),
        },
        {
          key: 'row-action-archive',
          onClick: () => setArchiveTargetFounders([founder]),
          label: 'Archive',
          hidden:
            !hasAccessToAction('founder.details.update') ||
            founder.status === 'Archived',
        },
      ]}
    />
  );
}

export default FoundersRowActions;
